// Транслит русского алфавита в латиницу (ICAO Doc 9303 / GOST 7.79).
const CYR_MAP: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'yo',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'kh',
  ц: 'ts',
  ч: 'ch',
  ш: 'sh',
  щ: 'sch',
  ъ: '',
  ы: 'y',
  ь: '',
  э: 'e',
  ю: 'yu',
  я: 'ya',
};

const SYMBOL_MAP: Record<string, string> = { '№': 'no', '&': 'and', '@': 'at' };

const FALLBACK = 'place';
const MAX_LEN = 64;

export function slugify(input: string): string {
  // Apply Cyrillic transliteration BEFORE NFD normalization, because some
  // Cyrillic letters (е.g. й = и + combining breve U+0306) decompose under NFD
  // and would be misread after stripping combining marks.
  let preTrans = '';
  for (const ch of input.toLowerCase()) {
    if (CYR_MAP[ch] != null) preTrans += CYR_MAP[ch];
    else if (SYMBOL_MAP[ch] != null) preTrans += SYMBOL_MAP[ch];
    else preTrans += ch;
  }

  // NFD decomposition strips combining diacritical marks (é → e, ñ → n, etc.)
  // after Cyrillic has already been transliterated.
  const lower = preTrans.normalize('NFD').replace(/[̀-ͯ]/g, '');

  const result = lower
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_LEN)
    .replace(/-+$/g, '');

  return result.length === 0 ? FALLBACK : result;
}

export function nextSlugCandidate(base: string, attempt: number): string {
  if (attempt === 0) return base;
  const suffix = `-${attempt + 1}`;
  return base.slice(0, MAX_LEN - suffix.length) + suffix;
}
